/**
 * User-visible strings of the add-to-shopping-list controls (`AddToShoppingList.tsx`,
 * `BulkAddToShoppingListMobile.tsx`) and of the order-details list header
 * (`components/OrderDetails/Helpers/OrderProductTableHeader.tsx`), in en / fr / es.
 * `privacyHint` comes from `@ryerson/frontend.common` → `withTranslation.allListText`.
 */
import { LanguageContent, withTranslation } from "@ryerson/frontend.common";

type AddToShoppingListLabels = {
	createNewList: string;
	listName: string;
	createList: string;
	newShoppingList: string;
	hint: string;
	privacyHint: string;
	learnMore: string;
	successMessage: string;
	addToShoppingList: string;
	addSelectedToShoppingList: string;
	addSelectedToShoppingCart: string;
	unselect: string;
};

/**
 * Strings by language; callers fall back to `en` for an unknown language. `learnMore` has no
 * reader.
 */
export const AddToShoppingListContent: LanguageContent<AddToShoppingListLabels> = {
	en: {
		createNewList: "Create New List",
		listName: "List Name",
		createList: "Create List",
		newShoppingList: "+ New Shopping List",
		hint: "Use shopping lists to save products for later.",
		privacyHint: withTranslation.allListText.en,
		learnMore: "Learn More",
		successMessage: "Added to Shopping List!",
		addToShoppingList: "Add to Shopping List",
		addSelectedToShoppingList: "Add Selected to Shopping List",
		unselect: "Unselect",
		addSelectedToShoppingCart: "Add Selected to Shopping Cart",
	},
	fr: {
		createNewList: "Créer une nouvelle liste",
		listName: "Nom de la liste",
		createList: "Créer une liste",
		newShoppingList: "+ Nouvelle liste d’achats",
		hint: "Utilisez les listes d’achats pour enregistrer des produits pour plus tard.",
		privacyHint: withTranslation.allListText.fr,
		learnMore: "En savoir plus",
		successMessage: "L’article a été ajouté à la liste d’achats.",
		addToShoppingList: "Ajouter à la liste d’achats",
		addSelectedToShoppingList: "Ajouter la sélection à la liste d’achats",
		unselect: "Désélectionner",
		addSelectedToShoppingCart: "Ajouter la sélection au panier d’achats",
	},
	es: {
		createNewList: "Crear nueva lista",
		listName: "Nombre de lista",
		createList: "Crear lista",
		newShoppingList: "+ Nueva lista de compras,",
		hint: "Usar listas de compras para guardar productos para más tarde.",
		privacyHint: withTranslation.allListText.es,
		learnMore: "Conocer más,",
		successMessage: "Se agregó a la lista de compras,",
		addToShoppingList: "Agregar a la lista de la compra",
		addSelectedToShoppingList: "Agregar seleccionado a Lista de compras",
		unselect: "Cancelar selección",
		addSelectedToShoppingCart: "Agregar seleccionado al carrito de compras",
	},
};
